import { Box, Grid } from "@mui/material";
import DashboardCardsUI from "./DashboardCardsUI";
import DashboardCardSkeleton from "./DashboardCardSkeleton";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
import { newDashboardApi } from "../../../app/slices/mmtc/newDashboardSlice";
import DateSearchComponentForDashboard from "../../../components/customTable/DateSearchComponentForDashboard";
import DashboardCardsUIForDoubleValue from "./DashboardCardsUIForDoubleValue";

export default function NewDashboardCardContent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ✅ Default 1-day range: Yesterday → Today
  // const [queryParams, setQueryParams] = useState({
  //   startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  //   endDate: moment().format("YYYY-MM-DD"),
  // });
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  // ✅ Fetch dashboard data whenever date range changes
  useEffect(() => {
    if (queryParams.startDate && queryParams.endDate) {
      dispatch(newDashboardApi(queryParams));
    }
  }, [dispatch, queryParams]);

  // ✅ Redux selectors
  const sliceResponse = useSelector(
    (state) => state.newDashboard.newDashboard.data,
  );

  // console.log("[[[[[[]]]]]]]]]]]]][[]]]-----------",sliceResponse)
  const stateLoading = useSelector((state) => state.newDashboard.loading);

  // ✅ Card configurations (data-driven)
  const cards = [
    {
      title: "Total Sales",
      value: `₹ ${sliceResponse?.totalAmount || 0}`,
      img: "/icons/TotalAmount.png",
    },
    {
      title: "Augmont Total",
      value: `₹ ${sliceResponse?.augmonttotal || 0}`,
      img: "/icons/AUGMOUNT.png",
    },
    {
      title: "MMTC Total",
      value: `₹ ${sliceResponse?.mmtcTotals || 0}`,
      img: "/icons/mmtc copy.png",
    },
    {
      title: "B2B Total",
      value: `₹ ${sliceResponse?.B2Btotal.Total || 0}`,
      a: `₹ ${sliceResponse?.B2Btotal.augmontB2Btotal || 0}`,
      b: `₹ ${sliceResponse?.B2Btotal.mmtcB2Btotal || 0}`,
      img: "/icons/B2B.png",
    },
    {
      title: "B2C Total",
      value: `₹ ${sliceResponse?.B2Ctotal.Total || 0}`,
      a: `₹ ${sliceResponse?.B2Ctotal.B2Caugmonttotal || 0}`,
      b: `₹ ${sliceResponse?.B2Ctotal.B2Cmmtctotal || 0}`,
      img: "/icons/B2C.png",
    },
    {
      title: "Total Txn",
      value: `${sliceResponse?.TotalTransactionCount || 0}`,
      bajajdate: `${sliceResponse?.TotalTransactionCount || 0}`,
      img: "/icons/TotalAmount.png",
    },
    {
      title: "B2B Count",
      value: `${sliceResponse?.B2BTransactionCount || 0}`,
      bajajdate: `${sliceResponse?.B2BTransactionCount || 0}`,
      img: "/icons/TotalAmount.png",
    },
    {
      title: "B2C Count",
      value: `${sliceResponse?.B2CTransactionCount || 0}`,
      bajajdate: `${sliceResponse?.B2CTransactionCount || 0}`,
      img: "/icons/TotalAmount.png",
    },
    {
      title: "New Users",
      value: `${sliceResponse?.totalNewUsers || 0}`,
      bajajdate: `${sliceResponse?.totalNewUsers || 0}`,
      img: "/icons/B2C.png",
    },
    {
      title: "KYC Users",
      value: `${sliceResponse?.totalKycUsers || 0}`,
      bajajdate: `${sliceResponse?.totalKycUsers || 0}`,
      img: "/icons/B2C.png",
    },
    {
      title: "East",
      value: `₹ ${sliceResponse?.zonalwisetotal?.east?.totalamount || 0}`,
      a: `₹ ${sliceResponse?.zonalwisetotal?.east?.augmontTotal || 0}`,
      b: `₹ ${sliceResponse?.zonalwisetotal?.east?.mmtcTotal || 0}`,
      img: "/icons/east-icon.png",
    },
    {
      title: "West",
      value: `₹ ${sliceResponse?.zonalwisetotal?.west?.totalamount || 0}`,
      a: `₹ ${sliceResponse?.zonalwisetotal?.west?.augmontTotal || 0}`,
      b: `₹ ${sliceResponse?.zonalwisetotal?.west?.mmtcTotal || 0}`,
      img: "/icons/west-icon.png",
    },
    {
      title: "North",
      value: `₹ ${sliceResponse?.zonalwisetotal?.north?.totalamount || 0}`,
      a: `₹ ${sliceResponse?.zonalwisetotal?.north?.augmontTotal || 0}`,
      b: `₹ ${sliceResponse?.zonalwisetotal?.north?.mmtcTotal || 0}`,
      img: "/icons/north-icon.png",
    },
    {
      title: "South",
      value: `₹ ${sliceResponse?.zonalwisetotal?.south?.totalamount || 0}`,
      a: `₹ ${sliceResponse?.zonalwisetotal?.south?.augmontTotal || 0}`,
      b: `₹ ${sliceResponse?.zonalwisetotal?.south?.mmtcTotal || 0}`,
      img: "/icons/south-icon.png",
    },
    {
      title: "Jewellery Total",
      value: `₹ ${sliceResponse?.jewelleryTotals || 0}`,
      img: "/icons/Jewellery.png",
    },
    {
      title: "Fintso Total",
      value: `₹ ${sliceResponse?.fintsoTotal || 0}`,
      img: "/icons/fintso-logo-icon.png",
    },
     {
      title: "Zdvisor Total",
      value: `₹ ${sliceResponse?.zdvisorTotal || 0}`,
      img: "/icons/zdvisor-logo-icon.png",
    },
    {
      title: "Bajaj Total",
      value: `₹ ${sliceResponse?.bajajTotals || 0}`,
      bajajdate: `${sliceResponse?.bajajdate || 0}`,
      img: "/icons/bajaj.png",
    },
    // {
    //   title: "Asgari",
    //   value: `₹ ${sliceResponse?.zonalwisetotal?.Asgari?.totalamount || 0}`,
    //   a: `₹ ${sliceResponse?.zonalwisetotal?.Asgari?.augmontTotal || 0}`,
    //   b: `₹ ${sliceResponse?.zonalwisetotal?.Asgari?.mmtcTotal || 0}`,
    //   img: "/icons/asgari copy.png",
    // },
    {
      title: "Gold Weight",
      value: `${sliceResponse?.GoldWeightTotal?.Total || 0} gm`,
      a: `${sliceResponse?.GoldWeightTotal?.augmontgoldweighttotal || 0} gm`,
      b: `${sliceResponse?.GoldWeightTotal?.mmtcGoldweighttotal || 0} gm`,
      img: "/icons/GOLD WEIGHT.png",
    },
    {
      title: "Silver Weight",
      value: `${sliceResponse?.SilverWeightTotal?.Total || 0} gm`,
      a: `${sliceResponse?.SilverWeightTotal?.augmontsilverweighttotal || 0} gm`,
      b: `${sliceResponse?.SilverWeightTotal?.mmtcSilverweighttotal || 0} gm`,
      img: "/icons/SILVER WEIGHT.png",
    },

    // { title: "East", value: `₹ ${sliceResponse?.zonalwisetotal?.east?.totalamount || 0}`, img: "/icons/east-icon.png" },
    // { title: "West", value: `₹ ${sliceResponse?.zonalwisetotal?.west?.totalamount || 0}`, img: "/icons/west-icon.png" },
    // { title: "North", value: `₹ ${sliceResponse?.zonalwisetotal?.north || 0}`, img: "/icons/north-icon.png" },
    // { title: "South", value: `₹ ${sliceResponse?.zonalwisetotal?.south?.totalamount || 0}`, img: "/icons/south-icon.png" },
    // { title: "Asgari", value: `₹ ${sliceResponse?.zonalwisetotal?.Asgari || 0}`, img: "/icons/asgari copy.png" },
  ];

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <DateSearchComponentForDashboard onSearch={handleSearch} />
      </Box>

      <Grid container spacing={2}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
            {!stateLoading ? (
              card.title === "East" ||
              card.title === "West" ||
              card.title === "North" ||
              card.title === "South" ||
              card.title === "Asgari" ||
              card.title === "Gold Weight" ||
              card.title === "Silver Weight" ||
              card.title === "B2B Total" ||
              card.title === "B2C Total" ? (
                <DashboardCardsUIForDoubleValue
                  title={card.title}
                  discription={card.value}
                  img={card.img}
                  a={card.a}
                  b={card.b}
                />
              ) : (
                <DashboardCardsUI
                  title={card.title}
                  discription={card.value}
                  img={card.img}
                  bajajdate={card?.bajajdate}
                />
              )
            ) : (
              <DashboardCardSkeleton />
            )}
          </Grid>
        ))}
      </Grid>
    </>

    // <>
    //   <Box sx={{ mb: 2 }}>
    //     <DateSearchComponentForDashboard onSearch={handleSearch} />
    //   </Box>

    //   <Grid container spacing={2}>
    //     {cards.map((card, index) => (
    //       <Grid item xs={12} sm={6} md={4} lg={2.3} key={index}>
    //         {!stateLoading ? (
    //           {if (card.title === "B2B Total" || card.title === "B2C Total") {
    //             <DashboardCardsUIForDoubleValue
    //               title={card.title}
    //               discription={card.value}
    //               img={card.img}
    //             />
    //           }} else (
    //           <DashboardCardsUI
    //             title={card.title}
    //             discription={card.value}
    //             img={card.img}
    //           />)
    //         ) : (
    //           <DashboardCardSkeleton />
    //         )}
    //       </Grid>
    //     ))}
    //   </Grid>
    // </>
  );
}
